export const PROJECT = 'consumer'
